import { PageHeader } from "@/components/design";
import { formatCurrency, formatHours } from "@/features/dashboard/utils";
import {
  EQUIPMENT_TYPE_LABELS,
} from "@/features/equipment/api";
import { EquipmentStatusBadge, EquipmentTypeBadge } from "@/features/equipment/components/equipment-badges";
import { useDemo } from "../demo-context";

export function DemoEquipmentPage() {
  const { state } = useDemo();
  const items = state.equipment;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Equipment & Assets"
        description="Fleet usage, hourly costs, and site assignments across Ridgepoint sites."
      />

      <div className="overflow-x-auto rounded-xl border bg-card-white shadow-[var(--shadow-card)]">
        <table className="w-full min-w-[960px] text-sm">
          <thead>
            <tr className="border-b bg-bg-light text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3">Equipment ID</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Site</th>
              <th className="px-4 py-3">Hourly cost</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Period hrs</th>
              <th className="px-4 py-3">Est. cost</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id} className="border-b border-border/60 last:border-0 hover:bg-bg-light/50">
                <td className="px-4 py-3 font-mono font-medium text-navy-deep">{item.equipmentId}</td>
                <td className="px-4 py-3 font-medium">{item.name}</td>
                <td className="px-4 py-3">
                  <EquipmentTypeBadge type={item.type} />
                </td>
                <td className="px-4 py-3 text-muted-foreground">{item.siteCode ?? "—"}</td>
                <td className="px-4 py-3 tabular-nums">
                  {item.hourlyCost != null ? `${formatCurrency(item.hourlyCost)}/hr` : "—"}
                </td>
                <td className="px-4 py-3">
                  <EquipmentStatusBadge status={item.status} />
                </td>
                <td className="px-4 py-3 tabular-nums">{formatHours(item.periodUsageHours)}</td>
                <td className="px-4 py-3 tabular-nums">
                  {item.estimatedPeriodCost != null ? formatCurrency(item.estimatedPeriodCost) : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="text-sm text-muted-foreground">
        Equipment hours roll into site cost reports and worker time entries. Certifications are
        checked when operators are assigned to regulated assets (
        {Object.values(EQUIPMENT_TYPE_LABELS).slice(0, 3).join(", ")}, etc.).
      </p>
    </div>
  );
}
